import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import Footer from "./Footer";
import img1 from "../Ecomphotos/s11.jpg";
import img2 from "../Ecomphotos/s12.jpg";
import img3 from "../Ecomphotos/s13.jpg";
import img4 from "../Ecomphotos/s14.jpg";
import img5 from "../Ecomphotos/s15.jpg";
import img6 from "../Ecomphotos/s16.jpg";

function Services() {
  // Page load hone par top par scroll kare
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      {/* <Navr/> */}
      <div className="services-page">
        {/* 1. HERO HEADER */}
        <header className="contact-hero">
          <div className="container">
            <h1 className="hero-title text-white">OUR SERVICES</h1>
            <p className="lead text-light letter-spacing-2">
              EVENTS • WEDDINGS • PRODUCTION • MANAGEMENT
            </p>
          </div>
        </header>

        {/* 2. DETAILED SERVICES GRID */}
        <section className="container py-5">
          <div className="row g-4">
            <div className="col-12 text-center mb-5">
              <h2 className="section-title ">What We Offer</h2>
              <p className="text-muted w-75 mx-auto">
                We don’t just provide equipment — we plan, design and execute
                memorable events. Tillu Events delivers complete event solutions
                tailored to weddings, parties, corporate functions and
                large-scale shows.
              </p>
            </div>

            {/* Service 1: DJ Setup */}
            <div className="col-md-4">
              <div className="service-box">
                <div className="service-img-wrapper">
                  <span className="category-badge">Most Popular</span>
                  <img src={img1} className="service-img" alt="DJ Setup" />
                </div>
                <div className="service-content">
                  <h3 className="text-white fw-bold">
                    DJ & Music Entertainment
                  </h3>
                  <p className="text-secondary small">
                    Professional DJs with premium sound systems to energize
                    weddings, receptions, parties and live events of any scale.
                  </p>
                  <ul className="text-secondary small ps-3">
                    <li>Professional Wedding & Party DJs</li>
                    <li>High-Quality Sound Systems</li>
                    <li>Customized Playlists & Live Mixing</li>
                  </ul>
                </div>
              </div>
            </div>

            {/* Service 2: Intelligent Lighting */}
            <div className="col-md-4">
              <div className="service-box">
                <div className="service-img-wrapper">
                  <img src={img2} className="service-img" alt="Lights" />
                </div>
                <div className="service-content">
                  <h3 className="text-white fw-bold">Event Lighting Design</h3>
                  <p className="text-secondary small">
                    Creative lighting concepts using moving heads, beam lights
                    and LED fixtures to transform venues and set the perfect
                    mood.
                  </p>
                  <ul className="text-secondary small ps-3">
                    <li>Stage & Dance Floor Lighting</li>
                    <li>Beam, Wash & Laser Effects</li>
                    <li>DMX Controlled Shows</li>
                  </ul>
                </div>
              </div>
            </div>

            {/* Service 3: Visuals & LED */}
            <div className="col-md-4">
              <div className="service-box">
                <div className="service-img-wrapper">
                  <img src={img3} className="service-img" alt="LED Wall" />
                </div>
                <div className="service-content">
                  <h3 className="text-white fw-bold">
                    LED Walls & Visual Production
                  </h3>
                  <p className="text-secondary small">
                    High-definition LED walls and visuals for weddings,
                    concerts, corporate events and brand promotions.
                  </p>
                  <ul className="text-secondary small ps-3">
                    <li>Wedding Visuals & Live Feeds</li>
                    <li>Branding & Event Graphics</li>
                    <li>3D Visuals & Video Playback</li>
                  </ul>
                </div>
              </div>
            </div>

            {/* Service 4: Special Effects */}
            <div className="col-md-4">
              <div className="service-box">
                <div className="service-img-wrapper">
                  <img src={img4} className="service-img" alt="SFX" />
                </div>
                <div className="service-content">
                  <h3 className="text-white fw-bold">Special Event Effects</h3>
                  <p className="text-secondary small">
                    Cold pyro, CO₂ jets, confetti blasts and low fog effects to
                    create grand entries and magical moments.
                  </p>
                </div>
              </div>
            </div>

            {/* Service 5: Truss & Stage */}
            <div className="col-md-4">
              <div className="service-box">
                <div className="service-img-wrapper">
                  <img src={img5} className="service-img" alt="Truss" />
                </div>
                <div className="service-content">
                  <h3 className="text-white fw-bold">Stage & Truss Setup</h3>
                  <p className="text-secondary small">
                    Safe and stylish aluminum truss structures and stage designs
                    for lighting, sound, LED walls and decorative elements.
                  </p>
                </div>
              </div>
            </div>

            {/* Service 6: Corporate Events */}
            <div className="col-md-4">
              <div className="service-box">
                <div className="service-img-wrapper">
                  <img src={img6} className="service-img" alt="Corporate" />
                </div>
                <div className="service-content">
                  <h3 className="text-white fw-bold">
                    Corporate & Conference Events
                  </h3>
                  <p className="text-secondary small">
                    End-to-end solutions for conferences, seminars and corporate
                    functions with professional audio, visuals and presentation
                    support.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* 3. PRICING PACKAGES */}
        <section className="py-5" style={{ background: "#050505" }}>
          <div className="container py-5">
            <h2 className="text-center mb-5 display-5 fw-bold text-white">
              Popular Packages
            </h2>

            <div className="row align-items-center g-4">
              {/* Package 1: Silver */}
              <div className="col-lg-4">
                <div className="pricing-card">
                  <h4 className="text-secondary">SILVER PLAN</h4>
                  <div className="price-tag">Basic</div>
                  <p className="text-secondary small">
                    House Parties & Small Events
                  </p>

                  <hr className="border-secondary" />
                  <ul className="feature-list">
                    <li>2 Top Speakers (JBL/RCF)</li>
                    <li>1 Bass Bin</li>
                    <li>Basic DJ Console</li>
                    <li>2 LED Par Lights</li>
                    <li>Transport Included (Local)</li>
                  </ul>
                  <Link
                    to="/contact"
                    className="btn btn-outline-light w-100 rounded-pill"
                  >
                    Select Plan
                  </Link>
                </div>
              </div>

              {/* Package 2: Gold (Highlighted) */}
              <div className="col-lg-4">
                <div className="pricing-card featured">
                  <div
                    className="category-badge"
                    style={{
                      top: "-10px",
                      right: "50%",
                      transform: "translateX(50%)",
                    }}
                  >
                    BEST VALUE
                  </div>
                  <h4 className="text-info mt-2">GOLD PLAN</h4>
                  <div className="price-tag text-info">Wedding</div>
                  <p className="text-secondary small">Weddings & Receptions</p>

                  <hr className="border-info" />
                  <ul className="feature-list">
                    <li>Premium Sound System</li>
                    <li>Professional DJ & Event Host</li>
                    <li>Decorative Event Lighting</li>
                    <li>Stage & Truss Setup</li>
                    <li>On-site Event Coordination</li>
                  </ul>

                  <Link
                    to="/contact"
                    className="btn-neon-lg d-block text-center"
                    style={{ fontSize: "1rem" }}
                  >
                    Book Gold Plan
                  </Link>
                </div>
              </div>

              {/* Package 3: Platinum */}
              <div className="col-lg-4">
                <div className="pricing-card">
                  <h4 className="text-secondary">PLATINUM PLAN</h4>
                  <div className="price-tag">Concert</div>
                  <p className="text-secondary small">
                    Concerts & Grand Events
                  </p>

                  <hr className="border-secondary" />
                  <ul className="feature-list">
                    <li>Concert-Grade Sound System</li>
                    <li>Large LED Wall Setup</li>
                    <li>Advanced Lighting & Special Effects</li>
                    <li>Full Stage & Truss Structure</li>
                    <li>Complete Event Management Team</li>
                  </ul>

                  <Link
                    to="/contact"
                    className="btn btn-outline-light w-100 rounded-pill"
                  >
                    Select Plan
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* 4. CTA FOOTER */}
        <section className="py-5 bg-dark text-center border-top border-secondary">
          <div className="container">
            <h3 className="text-white mb-3">Need a Custom Event Plan?</h3>

            <p className="text-muted mb-4">
              Every event is unique. Tell us your vision and budget, and Tillu
              Events will design a custom solution just for you.
            </p>

            <Link
              to="/contact"
              className="btn btn-light rounded-pill px-5 fw-bold"
            >
              Call Us Now
            </Link>
          </div>
        </section>
      </div>
      <Footer />
    </>
  );
}

export default Services;
